import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Layout from "../../../layout";
//import PageMenuBarTop from "./PageMenuBarTop";
import PageMenuBarTop from "../../PageMenuBarTop";
import PageMenuBarBottom from "./PageMenuBarBottom";
import "../pages.css";
import { createStructuredSelector } from "reselect";
import AffiliateNetworksModal from "./PageModal";
import EditAffiliateNetworksModal from "./EditPageModal";
import DeletePageModal from "./DeletePageModal";
import {
  makeSelectAffiliatedNetworkDataLoaded,
  makeSelectIsDeleteAffiliateNetworkDataSent,
  makeSelectIsAllAffiliateNetworksDataLoaded,
  makeSelectIsNewAffiliateNetworkDataSent,
  makeSelectIsEditAffiliateNetworkDataReceived,
  makeSelectIsPatchedAffiliateNetworkDataSent,
  makeSelectCustomAffiliateNetworkData,
  makeSelectCustomAffiliateNetworkDataById,
  makeSelectAllChartsDataLoaded,
  makeSelectIsChartsDataLoaded,
  makeSelectIsAffNetworkArchived,
  makeSelectError,
  makeSelectArchiveDeleteResponseAffNetwork,
} from "./selectors";
import {
  deleteAffiliateNetwork,
  closeEditAffiliateNetworkDialogue,
} from "./actions";
import { makeSelectToken } from "../../../registration/LoginRegister/selectors";
import { makeSelectDomainsDataReceived } from "../../Settings/Domains/selectors";
import { loadCustomDomains } from "../../Settings/Domains/actions";
import "./affiliateNetworks.css";
import * as affiliatedNetworksActions from "./actions";
import produce from "immer";
//import {Fade} from "@progress/kendo-react-animation";
import GridClassComponent from "./../../grid/grid";
import MenuCharts from "./../../charts/index";
import { makeSelectMoveToWorkspace } from "../../../moveToWorkspaceRedux/selectors";
import { moveToWorkspace } from "../../../moveToWorkspaceRedux/actions";
import LoadingPanel from "./../../grid/loader/loader";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";

class AffiliateNetworks extends Component {
  state = {
    visibleAffiliateNetworksDialog: false,
    visibleEditAffiliateNetworksDialog: false,
    visibleDeleteAffiliateNetworksDialog: false,
    selectedAffiliateNetwork: null,
    affiliateDialogueNextBtnClicked: false,
    loadedNetworksData: null,
    loadedDomainsData: null,
    editAffiliateNetworkId: null,
    success_msg: "",
    isDataGettingLoaded: true,
    isAffiliateNetworkDeleted: false,
    isNewAffiliateNetworkAdded: false,
    isAffiliateNetworkPatched: false,
    isCutomButtonClicked: false,
    archivedSuccessfully: false,
    updateState: false,
    paginationSize: 10,
    selectedListReceivedFromGrid: [],
    isDuplicate: false,
    isArchive: false,
    archiveType: "",
    charts: {
      showCharts: false,
      chartsData: null,
      isChartsDataLoaded: false,
    },
    pageContentHeight: "500",
    groupingValues: {
      main: "",
      group1: "",
      group2: "",
    },
    showCalendar: false,
    showColumnsModal: false,
    sorting: {
      order: "visits",
      sort: "ASC",
    },
    loader: false,
    pagination: {
      skip: 0,
      take: 50,
      page: 1,
      total: 0,
      totalPages: 1,
      blur: {
        blurFirst: true,
        blurLast: true,
        blurPrev: true,
        blurNext: true,
      },
    },
    filterStatus: "all",
    backendErrors: {
      error: false,
      errorMsg: "",
    },
    disableReport: false,
    reportCount: 0,
    archiveDeleteResponseAffNetwork: null,
    showNoRecordFound: false,
  };

  fetchAffiliateNetworks = () => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
        draft.selectedListReceivedFromGrid = [];
      })
    );
    let search = JSON.parse(localStorage.getItem("search"));
    this.setState(
      produce((draft) => {
        draft.groupingValues = search.groupingValues;
      })
    );
    return this.props.dispatchLoadAffiliateNetwork({
      accessToken: this.props.accessToken,
      searchData: JSON.parse(localStorage.getItem("search")),
      sorting: this.state.sorting,
      primaryPage: true,
      dataType: "full",
    });
  };
  fetchDomains = async () => {
    return this.props.dispatchLoadDomains(this.props.accessToken);
  };

  fetchAllCustomAffiliateNetworks = () => {
    return this.props.dispatchLoadAllCustomAffiliateNetworks(
      this.props.accessToken
    );
  };

  fetchCustomAffiliateNetworkById = () => {
    return this.props.dispatchLoadCustomAffiliateNetworkById({
      accessToken: this.props.accessToken,
      customAffiliateNetworkId: this.state.selectedAffiliateNetwork,
    });
  };
  fetchChartsData = () => {
    return this.props.dispatchLoadChartsData({
      accessToken: this.props.accessToken,
      dates: JSON.parse(localStorage.getItem("search")).modifiedDate,
    });
  };

  deleteAffiliateNetwork = () => {
    let ids = [];
    for (let i = 0; i < this.state.selectedListReceivedFromGrid.length; i++) {
      ids.push(this.state.selectedListReceivedFromGrid[i].id);
    }
    return this.props.dispatchDeleteAffiliateNetwork({
      accessToken: this.props.accessToken,
      networkId: ids,
    });
  };

  componentDidMount() {
    this.fetchDomains();
    // check if main group value is not affiliate network value...
    // than set it to affiliate network value to avoid any errors.
    if (
      JSON.parse(localStorage.getItem("search")).groupingValues.main !==
      "Affiliate Network"
    ) {
      let search = JSON.parse(localStorage.getItem("search"));
      search.groupingValues.main = "Affiliate Network";
      localStorage.setItem("search", JSON.stringify(search));
    }
    // set initial grouping values in state to be passed on to the grid...
    // so that is does not show error grouping values of none.
    if (JSON.parse(localStorage.getItem("search"))) {
      this.setState(
        produce((draft) => {
          draft.groupingValues.main = JSON.parse(
            localStorage.getItem("search")
          ).groupingValues.main;
          draft.groupingValues.group1 = JSON.parse(
            localStorage.getItem("search")
          ).groupingValues.group1;
          draft.groupingValues.group2 = JSON.parse(
            localStorage.getItem("search")
          ).groupingValues.group2;
          draft.filterStatus = JSON.parse(
            localStorage.getItem("search")
          ).filterStatus;
          draft.reportCount = JSON.parse(
            localStorage.getItem("search")
          ).report.reportCount;
        })
      );
    }
    // if (this.state.loadedNetworksData === null) {  }
    this.fetchAllCustomAffiliateNetworks();

    // code for setting grid height initially
    let pageMenuHeight = Number(
      document.getElementById("page_menu").clientHeight
    );
    let pageFullHeight = Number(
      document.getElementsByTagName("html")[0].clientHeight
    );
    this.setState(
      produce((draft) => {
        draft.pageContentHeight = pageFullHeight - pageMenuHeight - 127;
      })
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.domainsDataReceived !== this.props.domainsDataReceived &&
      this.props.domainsDataReceived !== null
    ) {
      this.fetchAffiliateNetworks();
    }

    if (
      prevProps.loadAffiliateNetworkData !==
        this.props.loadAffiliateNetworkData &&
      this.props.loadAffiliateNetworkData !== null &&
      this.props.loadAffiliateNetworkData !== undefined &&
      this.props.domainsDataReceived &&
      this.props.domainsDataReceived !== []
    ) {
      this.setState(
        produce((draft) => {
          draft.loadedNetworksData = this.props.loadAffiliateNetworkData;
          if (this.props.loadAffiliateNetworkData.total) {
            draft.pagination.total =
              this.props.loadAffiliateNetworkData.total.totalRows;
          }
          draft.loader = false;
        })
      );
      this.setTotalPagination();
      setTimeout(() => {
        this.setPaginationUI();
      }, 50);
    } else {
      if (!this.state.showNoRecordFound) {
        setTimeout(() => this.setState({ showNoRecordFound: true }), 500);
      }
    }
    // move to workspace function
    if (
      prevProps.isMovedToWorkspace !== this.props.isMovedToWorkspace &&
      this.props.isMovedToWorkspace === true
    ) {
      this.fetchAffiliateNetworks();
      this.setState(
        produce((draft) => {
          draft.loader = false;
        })
      );
    }
    // set the charts data
    if (prevProps.chartsAllDataLoaded !== this.props.chartsAllDataLoaded) {
      this.setState(
        produce((draft) => {
          draft.charts.chartsData = this.props.chartsAllDataLoaded;
        })
      );
    }

    // checks if network has been deleted and this.state.isAffiliateNetworkDeleted is set to true then logs the message
    // then sends a fetch request and make the isAffiliateNetworkDeleted to false so that it does not run in loop
    if (
      prevProps.isAffiliateNetworkDeleted !==
        this.props.isAffiliateNetworkDeleted &&
      this.props.isAffiliateNetworkDeleted === true &&
      this.state.isAffiliateNetworkDeleted === true
    ) {
      this.setState(
        produce((draft) => {
          draft.loader = false;
          draft.success_msg = "Affiliate network deleted successfully.";
          draft.isDataGettingLoaded = true;
          draft.isAffiliateNetworkDeleted =
            !this.state.isAffiliateNetworkDeleted;
          draft.visibleDeleteAffiliateNetworksDialog =
            !this.state.visibleDeleteAffiliateNetworksDialog;
        })
      );
      this.fetchAffiliateNetworks();
      setTimeout(() => {
        this.setState(
          produce((draft) => {
            draft.success_msg = "";
          })
        );
      }, 10000);
    }

    // check if network has been archived
    if (
      prevProps.isAffNetworkArchived !== this.props.isAffNetworkArchived &&
      this.props.isAffNetworkArchived === true
    ) {
      this.setState(
        produce((draft) => {
          draft.loader = false;
          draft.success_msg = "Affiliate network archived successfully.";
          draft.isDataGettingLoaded = true;
          draft.visibleDeleteAffiliateNetworksDialog =
            !this.state.visibleDeleteAffiliateNetworksDialog;
        })
      );
      this.fetchAffiliateNetworks();
      setTimeout(() => {
        this.setState(
          produce((draft) => {
            draft.success_msg = "";
          })
        );
      }, 10000);
    }

    // Check is props new affiliate network is true... if it is true then a new aff network has been added
    // then fetch affiliate networks again to get the fresh results
    // then make the state.isNewAffiliateNetwork Added to false to break the loop.
    if (
      prevProps.isNewAffiliateNetworkDataSent !==
        this.props.isNewAffiliateNetworkDataSent &&
      this.props.isNewAffiliateNetworkDataSent === true &&
      this.state.isNewAffiliateNetworkAdded === true
    ) {
      this.setState(
        produce((draft) => {
          draft.loader = false;
          draft.success_msg = "Affiliate Network Added Successfully.";
          draft.isDataGettingLoaded = true;
          draft.isNewAffiliateNetworkAdded =
            !this.state.isNewAffiliateNetworkAdded;
          if (this.state.visibleAffiliateNetworksDialog === true) {
            draft.visibleAffiliateNetworksDialog =
              !this.state.visibleAffiliateNetworksDialog;
          }
          if (this.state.visibleEditAffiliateNetworksDialog === true) {
            draft.visibleEditAffiliateNetworksDialog =
              !this.state.visibleEditAffiliateNetworksDialog;
          }
        })
      );
      this.fetchAffiliateNetworks();
      setTimeout(() => {
        this.setState(
          produce((draft) => {
            draft.success_msg = "";
          })
        );
      }, 10000);
    }

    // Check is props isPatchedAffiliateNetworkDataSent is true... if it is true then the network has been updated
    // then fetch affiliate networks again to get the fresh results
    // then make the state.isNewAffiliateNetwork Added to false to break the loop.
    if (
      prevProps.isPatchedAffiliateNetworkDataSent !==
        this.props.isPatchedAffiliateNetworkDataSent &&
      this.props.isPatchedAffiliateNetworkDataSent === true &&
      this.state.isAffiliateNetworkPatched === true
    ) {
      this.setState(
        produce((draft) => {
          draft.loader = false;
          draft.success_msg = "Affiliate Network Updated Successfully.";
          draft.isDataGettingLoaded = true;
          draft.isAffiliateNetworkPatched = false;
          draft.visibleEditAffiliateNetworksDialog =
            !this.state.visibleEditAffiliateNetworksDialog;
        })
      );
      this.fetchAffiliateNetworks();
      setTimeout(() => {
        this.setState(
          produce((draft) => {
            draft.success_msg = "";
          })
        );
      }, 10000);
    }

    // Check the error
    if (prevProps.Error !== this.props.Error && this.props.Error !== false) {
      if (this.props.Error && this.props.Error.data) {
        this.setState(
          produce((draft) => {
            draft.backendErrors.errorMsg =
              (this.props.Error.data.message
                ? this.props.Error.data.message
                : null) +
              ", " +
              (this.props.Error.data.error
                ? this.props.Error.data.error
                : null);
            draft.backendErrors.error = true;
            draft.loader = false;
          })
        );
      }
    }

    // check for archive or delete or restore message from backend
    if (
      prevProps.archiveDeleteResponseAffNetwork !==
        this.props.archiveDeleteResponseAffNetwork &&
      this.props.archiveDeleteResponseAffNetwork !== null
    ) {
      this.setState(
        produce((draft) => {
          draft.archiveDeleteResponseAffNetwork =
            this.props.archiveDeleteResponseAffNetwork;
        })
      );
      setTimeout(() => {
        this.setState(
          produce((draft) => {
            draft.archiveDeleteResponseAffNetwork = null;
          })
        );
      }, 10000);
    }
  }

  // toggle modal windows
  toggleAddAffiliateNetworkDialog = () => {
    this.setState({ ...this.state, affiliateDialogueNextBtnClicked: false });
    this.setState(
      produce((draft) => {
        draft.visibleAffiliateNetworksDialog =
          !this.state.visibleAffiliateNetworksDialog;
      })
    );
    this.setState(
      produce((draft) => {
        draft.selectedAffiliateNetwork = null;
      })
    );
  };
  closeAffiliateNetworkDialogueAfterSubmission = (data) => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
        draft.affiliateDialogueNextBtnClicked = false;
        if (data === "Add_Affiliate") {
          draft.affiliateDialogueNextBtnClicked =
            !this.state.affiliateDialogueNextBtnClicked;
          draft.isNewAffiliateNetworkAdded = true;
        }
        if (data === "Update_Affiliate") {
          draft.isAffiliateNetworkPatched = true;
        }
      })
    );

    setTimeout(() => {
      this.fetchAffiliateNetworks();
    }, 1000);
  };
  deleteAffiliateNetworkOnSubmit = () => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
        draft.isAffiliateNetworkDeleted = !this.state.isAffiliateNetworkDeleted;
      })
    );
    this.deleteAffiliateNetwork();
  };
  openEditAffiliateNetworkDialog = (data) => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
      })
    );
    if (data === "Edit") {
      this.setState(
        produce((draft) => {
          draft.isDuplicate = false;
        })
      );
    } else if (data === "Duplicate") {
      this.setState(
        produce((draft) => {
          draft.isDuplicate = true;
        })
      );
    }
    this.setState(
      produce((draft) => {
        draft.editAffiliateNetworkId =
          this.state.selectedListReceivedFromGrid[0].id;
      })
    );
    setTimeout(() => {
      if (this.state.editAffiliateNetworkId) {
        this.setState(
          produce((draft) => {
            draft.visibleEditAffiliateNetworksDialog =
              !this.state.visibleEditAffiliateNetworksDialog;
          })
        );
      }
    }, 200);
  };
  closeEditAffiliateNetworkDialog = () => {
    this.setState(
      produce((draft) => {
        draft.visibleEditAffiliateNetworksDialog =
          !this.state.visibleEditAffiliateNetworksDialog;
      })
    );
    this.props.resetEditAffNetworkData();
  };
  openDeleteAffiliateNetworkDialog = () => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
      })
    );
    this.setState(
      produce((draft) => {
        draft.editAffiliateNetworkId =
          this.state.selectedListReceivedFromGrid[0].id;
      })
    );
    setTimeout(() => {
      this.setState(
        produce((draft) => {
          draft.visibleDeleteAffiliateNetworksDialog =
            !this.state.visibleDeleteAffiliateNetworksDialog;
        })
      );
      this.setState(
        produce((draft) => {
          draft.loader = false;
        })
      );
    }, 300);
  };
  closeDeleteAffiliateNetworkDialog = () => {
    this.setState(
      produce((draft) => {
        draft.visibleDeleteAffiliateNetworksDialog =
          !this.state.visibleDeleteAffiliateNetworksDialog;
      })
    );
    this.fetchAffiliateNetworks();
  };

  selectAffiliateNetwork = (e) => {
    this.setState({ ...this.state, selectedAffiliateNetwork: e.target.id });
    document.getElementById(e.target.id).style.border = "1px solid #e0358b";
    if (this.state.selectedAffiliateNetwork !== null) {
      document.getElementById(
        this.state.selectedAffiliateNetwork
      ).style.border = "1px solid white";
    }
  };
  affiliateDialogueNextClicked = () => {
    if (this.state.selectedAffiliateNetwork !== "custom-affiliate-network") {
      this.fetchCustomAffiliateNetworkById();
      // this.setState(produce(draft => { draft.loader = false; }));
    }
    this.setState({ ...this.state, affiliateDialogueNextBtnClicked: true });
    this.toggleLoader();
    if (this.state.selectedAffiliateNetwork === "custom-affiliate-network") {
      this.setState(
        produce((draft) => {
          draft.loader = false;
        })
      );
    }
  };

  onSearchBtnClick = () => {
    this.setState(
      produce((draft) => {
        draft.search.isTagsSearchSelected =
          !this.state.search.isTagsSearchSelected;
      })
    );
  };

  sendSearchRequest = () => {
    let search = JSON.parse(localStorage.getItem("search"));
    if (
      search.groupingValues.main === "conversion" ||
      search.groupingValues.main === "months" ||
      search.groupingValues.main === "days" ||
      search.groupingValues.main === "hours"
    ) {
      this.setState(
        produce((draft) => {
          draft.disableReport = true;
        })
      );
    } else {
      this.setState(
        produce((draft) => {
          draft.disableReport = false;
        })
      );
    }
    localStorage.setItem("search", JSON.stringify(search));
    this.setState(
      produce((draft) => {
        draft.pagination.page = 1;
      })
    );
    this.setPaginationUI();
    this.fetchAffiliateNetworks();
    this.fetchChartsData();
    this.setState(
      produce((draft) => {
        draft.isAllLandersLoaded = false;
        draft.showCalendar = false;
      })
    );
  };

  changeSearchValues = (e, data) => {
    if (data === "tagsSearchValue") {
      this.setState(
        produce((draft) => {
          draft.search.tagsSearchValue = e.target.value;
        })
      );
    } else if (data === "inputSearchValue") {
      this.setState(
        produce((draft) => {
          draft.search.inputSearchValue = e.target.value;
        })
      );
    } else if (data === "grouping") {
      this.setState(
        produce((draft) => {
          draft.search.groupingValues.main = e[0];
          draft.search.groupingValues.group1 = e[1];
          draft.search.groupingValues.group2 = e[2];
        })
      );
    } else if (data === "dates") {
      this.setState(
        produce((draft) => {
          draft.search.dates.startDate = e.startDate;
          draft.search.dates.endDate = e.endDate;
        })
      );
    }
  };

  showCharts = () => {
    if (this.state.charts.showCharts !== true) {
      this.fetchChartsData();
    }
    this.setState(
      produce((draft) => {
        draft.charts.showCharts = !this.state.charts.showCharts;
        draft.showCalendar = false;
        draft.charts.isChartsDataLoaded = !this.state.charts.isChartsDataLoaded;
      })
    );
  };

  toggleDeleteArchiveModal = (data) => {
    this.setState(
      produce((draft) => {
        draft.visibleDeleteAffiliateNetworksDialog =
          !this.state.visibleDeleteAffiliateNetworksDialog;
        if (data === "Archive") {
          draft.archiveType = "Archive";
        } else if (data === "Delete") {
          draft.archiveType = "Delete";
        } else if (data === "Restore") {
          draft.archiveType = "Restore";
        } else if (data === "Close") {
          draft.archiveType = "";
        }
      })
    );
  };

  archiveAffiliateNetworkHandler = (data) => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
        draft.archivedSuccessfully = true;
        // draft.visibleDeleteAffiliateNetworksDialog = !this.state.visibleDeleteAffiliateNetworksDialog;
      })
    );
    let ids = [];
    for (let i = 0; i < this.state.selectedListReceivedFromGrid.length; i++) {
      ids.push(this.state.selectedListReceivedFromGrid[i].id);
    }
    this.props.dispatchArchiveAffiliateNetwork({
      accessToken: this.props.accessToken,
      anId: ids,
      value: data === "Archive" ? false : true,
    });
  };

  gridCheckedList = (list) => {
    this.setState(
      produce((draft) => {
        draft.selectedListReceivedFromGrid = list;
      })
    );
  };
  toggleCalendarWindow = () => {
    this.setState(
      produce((draft) => {
        draft.showCalendar = !this.state.showCalendar;
      })
    );
  };
  moveToWorkspaceMethod = (workspaceId) => {
    this.setState(
      produce((draft) => {
        draft.loader = true;
      })
    );
    let selectedList = [...this.state.selectedListReceivedFromGrid];
    let idStringList = [];
    for (let i = 0; i < this.state.selectedListReceivedFromGrid.length; i++) {
      idStringList.push(selectedList[i].id);
    }
    this.props.dispatchMoveToWorkspace({
      accessToken: this.props.accessToken,
      query: {
        type: "affilateNetwork",
        typeIdStringList: idStringList.join(","),
        workspaceId: workspaceId,
      },
    });
  };

  toggleColumnsModal = () => {
    this.setState(
      produce((draft) => {
        draft.showColumnsModal = !this.state.showColumnsModal;
      })
    );
  };

  changeSorting = (data) => {
    let sorting = { ...this.state.sorting };
    if (String(sorting.order) === String(data) && sorting.sort === "ASC") {
      this.setState(
        produce((draft) => {
          draft.sorting.sort = "DESC";
        })
      );
    } else if (
      String(sorting.order) === String(data) &&
      sorting.sort === "DESC"
    ) {
      this.setState(
        produce((draft) => {
          draft.sorting.sort = "ASC";
        })
      );
    } else if (String(sorting.order) !== String(data)) {
      this.setState(
        produce((draft) => {
          draft.sorting.order = data;
          draft.sorting.sort = "ASC";
        })
      );
    }
    setTimeout(() => {
      this.fetchAffiliateNetworks();
    }, 50);
  };

  setTotalPagination = () => {
    if (this.props.loadAffiliateNetworkData.total) {
      if (Number(this.props.loadAffiliateNetworkData.total.totalRows) > 0) {
        let totalRows = Number(
          this.props.loadAffiliateNetworkData.total.totalRows
        );
        if (totalRows <= this.state.pagination.take) {
          this.setState(
            produce((draft) => {
              draft.pagination.totalPages = 1;
            })
          );
        } else {
          if (totalRows % Number(this.state.pagination.take) > 0) {
            this.setState(
              produce((draft) => {
                draft.pagination.totalPages =
                  Math.floor(totalRows / this.state.pagination.take) + 1;
              })
            );
          } else {
            this.setState(
              produce((draft) => {
                draft.pagination.totalPages =
                  totalRows / this.state.pagination.take;
              })
            );
          }
        }
      } else {
        this.setState(
          produce((draft) => {
            draft.pagination.totalPages = 1;
          })
        );
      }
    }
  };
  setPaginationUI = () => {
    if (Number(this.state.pagination.totalPages) === 1) {
      this.setState(
        produce((draft) => {
          draft.pagination.blur.blurFirst = true;
          draft.pagination.blur.blurPrev = true;
          draft.pagination.blur.blurNext = true;
          draft.pagination.blur.blurLast = true;
        })
      );
    } else if (
      this.state.pagination.page === 1 &&
      this.state.pagination.totalPages > 1
    ) {
      this.setState(
        produce((draft) => {
          draft.pagination.blur.blurFirst = true;
          draft.pagination.blur.blurPrev = true;
          draft.pagination.blur.blurNext = false;
          draft.pagination.blur.blurLast = false;
        })
      );
    } else if (
      this.state.pagination.page !== 1 &&
      this.state.pagination.totalPages > 1 &&
      this.state.pagination.page < this.state.pagination.totalPages
    ) {
      this.setState(
        produce((draft) => {
          draft.pagination.blur.blurFirst = false;
          draft.pagination.blur.blurPrev = false;
          draft.pagination.blur.blurNext = false;
          draft.pagination.blur.blurLast = false;
        })
      );
    } else if (
      this.state.pagination.page !== 1 &&
      this.state.pagination.totalPages > 1 &&
      this.state.pagination.page === this.state.pagination.totalPages
    ) {
      this.setState(
        produce((draft) => {
          draft.pagination.blur.blurFirst = false;
          draft.pagination.blur.blurPrev = false;
          draft.pagination.blur.blurNext = true;
          draft.pagination.blur.blurLast = true;
        })
      );
    }
  };

  changePagination = (data) => {
    let search = JSON.parse(localStorage.getItem("search"));
    if (data === "first") {
      this.setState(
        produce((draft) => {
          draft.pagination.skip = 0;
          draft.pagination.page = 1;
        })
      );
      search.pagination.skip = 0;
    } else if (data === "prev") {
      let dataToSkip = this.state.pagination.skip - this.state.pagination.take;
      this.setState(
        produce((draft) => {
          draft.pagination.skip = dataToSkip;
          draft.pagination.page -= 1;
        })
      );
      search.pagination.skip = dataToSkip;
    } else if (data === "next") {
      let dataToSkip = this.state.pagination.skip + this.state.pagination.take;
      this.setState(
        produce((draft) => {
          draft.pagination.skip = dataToSkip;
          draft.pagination.page += 1;
        })
      );
      search.pagination.skip = dataToSkip;
    } else if (data === "last") {
      let dataToSkip =
        (this.state.pagination.totalPages - 1) * this.state.pagination.take;
      this.setState(
        produce((draft) => {
          draft.pagination.skip = dataToSkip;
          draft.pagination.page = this.state.pagination.totalPages;
        })
      );
      search.pagination.skip = dataToSkip;
    }

    localStorage.setItem("search", JSON.stringify(search));
    setTimeout(() => {
      this.fetchAffiliateNetworks();
    }, 50);
    this.setPaginationUI();
  };

  changeGridRowsNumber = (e) => {
    let search = JSON.parse(localStorage.getItem("search"));
    search.pagination.take = Number(e.target.value);
    search.pagination.skip = 0;
    this.setState(
      produce((draft) => {
        draft.pagination.skip = 0;
        draft.pagination.page = 1;
        draft.pagination.take = Number(e.target.value);
      })
    );
    localStorage.setItem("search", JSON.stringify(search));
    setTimeout(() => {
      this.fetchAffiliateNetworks();
    }, 50);
    this.setPaginationUI();
  };

  changeFilterStatusType = (e) => {
    let search = JSON.parse(localStorage.getItem("search"));
    search.filterStatus = e.target.value;
    this.setState(
      produce((draft) => {
        draft.filterStatus = e.target.value;
      })
    );
    localStorage.setItem("search", JSON.stringify(search));
    setTimeout(() => {
      this.fetchAffiliateNetworks();
    }, 50);
  };

  toggleLoader = () => {
    this.setState(
      produce((draft) => {
        draft.loader = !this.state.loader;
      })
    );
  };

  openNewReport = (data) => {
    let search = JSON.parse(localStorage.getItem("search"));
    if (data === "minus" && this.state.reportCount > 0) {
      search.report.reportCount = this.state.reportCount - 1;
      this.setState(
        produce((draft) => {
          draft.reportCount = this.state.reportCount - 1;
        })
      );
      localStorage.setItem("search", JSON.stringify(search));
    } else if (data === "plus") {
      let count = this.state.reportCount + 1;
      search.report["report" + count].name =
        this.state.selectedListReceivedFromGrid[0].name;
      search.report.reportCount = count;
      search.activeTab = count;
      this.setState(
        produce((draft) => {
          draft.reportCount = this.state.reportCount + 1;
        })
      );
      let startDate = search.modifiedDate.startDate;
      let endDate = search.modifiedDate.endDate;
      localStorage.setItem("search", JSON.stringify(search));
      setTimeout(() => {
        this.props.history.push({
          pathname: "/report",
          search:
            "id=" +
            this.state.selectedListReceivedFromGrid[0].id +
            "&reportType=" +
            search.groupingValues.main +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            "&new=true",
          hash: "",
        });
      }, 80);
    }
  };

  decreaseReportCount = () => {
    this.setState(
      produce((draft) => {
        draft.reportCount = Number(this.state.reportCount) - 1;
      })
    );
  };

  render() {
    return (
      <Fragment>
        <Layout
          reportCount={this.state.reportCount}
          decreaseReportCount={this.decreaseReportCount}
        >
          <div id="page_container" className="page_container">
            <div id="page_menu" className="page_menu_bar">
              <PageMenuBarTop
                sendSearchRequest={this.sendSearchRequest}
                showCharts={this.showCharts}
                toggleLoader={this.toggleLoader}
                showCalendar={this.state.showCalendar}
                toggleCalendarWindow={this.toggleCalendarWindow}
                pageType="Affiliate Network"
              />
              {this.state.charts.showCharts ? (
                <ResponsiveMenuCharts
                  data={this.state.charts.chartsData}
                  dates={
                    JSON.parse(localStorage.getItem("search")).modifiedDate
                  }
                />
              ) : null}
              {this.props.domainsDataReceived !== null ? (
                <PageMenuBarBottom
                  toggleAddAffiliateNetworkDialog={
                    this.toggleAddAffiliateNetworkDialog
                  }
                  loadedWorkspaces={this.props.domainsDataReceived.workspace}
                  selectedListReceivedFromGrid={
                    this.state.selectedListReceivedFromGrid
                  }
                  toggleDeleteArchiveModal={this.toggleDeleteArchiveModal}
                  openEditAffiliateNetworkDialog={
                    this.openEditAffiliateNetworkDialog
                  }
                  moveToWorkspaceMethod={this.moveToWorkspaceMethod}
                  toggleColumnsModal={this.toggleColumnsModal}
                  pagination={this.state.pagination}
                  changePagination={this.changePagination}
                  changeGridRowsNumber={this.changeGridRowsNumber}
                  changeFilterStatusType={this.changeFilterStatusType}
                  filterStatus={this.state.filterStatus}
                  reportId={
                    this.state.selectedListReceivedFromGrid.length > 0
                      ? this.state.selectedListReceivedFromGrid[0].id
                      : ""
                  }
                  disable={this.state.disableReport}
                  openNewReport={this.openNewReport}
                  reportCount={this.state.reportCount}
                />
              ) : null}
              <div className="page_content"></div>
              <div className="page_modal">
                {this.state.visibleAffiliateNetworksDialog && (
                  <AffiliateNetworksModal
                    state={this.state}
                    toggleAddAffiliateNetworkDialog={
                      this.toggleAddAffiliateNetworkDialog
                    }
                    closeAffiliateNetworkDialogueAfterSubmission={
                      this.closeAffiliateNetworkDialogueAfterSubmission
                    }
                    selectAffiliateNetwork={(e) =>
                      this.selectAffiliateNetwork(e)
                    }
                    affiliateDialogueNextClicked={
                      this.affiliateDialogueNextClicked
                    }
                    customDataReceived={
                      this.props.loadCustomAffiliateNetworkDataReceived
                    }
                    customDataReceivedById={
                      this.props.loadCustomAffiliateNetworkDataReceivedById
                    }
                    toggleLoader={this.toggleLoader}
                  />
                )}
                {this.state.loader && <LoadingPanel />}
              </div>
            </div>
            <div
              style={{ height: `calc(100% - 85px - 127px)` }}
              className="temporary_affiliate_network_page_data"
            >
              <GridClassComponent
                pageType="Affiliate Network"
                gridHeight={this.state.pageContentHeight}
                allDataLoaded={this.state.loadedNetworksData}
                paginationSize={this.state.paginationSize}
                gridCheckedList={(list) => this.gridCheckedList(list)}
                groupingValues={this.state.groupingValues}
                showColumnsModal={this.state.showColumnsModal}
                toggleColumnsModal={this.toggleColumnsModal}
                sorting={this.state.sorting}
                changeSorting={this.changeSorting}
                toggleLoader={this.toggleLoader}
                selectedListFromPage={this.state.selectedListReceivedFromGrid}
                showNoRecordFound={this.state.showNoRecordFound}
              />
            </div>
            {this.state.visibleEditAffiliateNetworksDialog && (
              <EditAffiliateNetworksModal
                state={this.state}
                openEditAffiliateNetworkDialog={
                  this.openEditAffiliateNetworkDialog
                }
                closeEditAffiliateNetworkDialog={
                  this.closeEditAffiliateNetworkDialog
                }
                closeAffiliateNetworkDialogueAfterSubmission={
                  this.closeAffiliateNetworkDialogueAfterSubmission
                }
                editAffiliateNetworkId={this.state.editAffiliateNetworkId}
                toggleLoader={this.toggleLoader}
              />
            )}
            {this.state.visibleDeleteAffiliateNetworksDialog && (
              <DeletePageModal
                state={this.state}
                closeDeleteAffiliateNetworkDialog={
                  this.closeDeleteAffiliateNetworkDialog
                }
                closeAffiliateNetworkDialogueAfterSubmission={
                  this.deleteAffiliateNetworkOnSubmit
                }
                editAffiliateNetworkId={this.state.editAffiliateNetworkId}
                toggleDeleteArchiveModal={this.toggleDeleteArchiveModal}
                archiveAffiliateNetworkHandler={
                  this.archiveAffiliateNetworkHandler
                }
              />
            )}
            {this.state.backendErrors.error && (
              <NotificationGroup
                style={{
                  alignItems: "flex-start",
                  flexWrap: "wrap-reverse",
                  left: "50%",
                  zIndex: 10000000,
                  top: "20px",
                  transform: "translateX(-50%)",
                }}
              >
                <Fade enter={true} exit={true}>
                  {this.state.backendErrors.error && (
                    <Notification
                      type={{ style: "error", icon: true }}
                      closable={true}
                      // onClose={() => this.setState({ backendErrors.error: false })}
                      onClose={() =>
                        this.setState(
                          produce((draft) => {
                            draft.backendErrors.error = false;
                          })
                        )
                      }
                    >
                      <span>{this.state.backendErrors.errorMsg}</span>
                    </Notification>
                  )}
                </Fade>
              </NotificationGroup>
            )}
            {this.state.archiveDeleteResponseAffNetwork && (
              <NotificationGroup
                style={{
                  alignItems: "flex-start",
                  flexWrap: "wrap-reverse",
                  left: "50%",
                  zIndex: 10000000,
                  top: "20px",
                  transform: "translateX(-50%)",
                }}
              >
                <Fade enter={true} exit={true}>
                  {this.state.archiveDeleteResponseAffNetwork && (
                    <Notification
                      type={{ style: "warning", icon: true }}
                      closable={true}
                      // onClose={() => this.setState({ backendErrors.error: false })}
                      onClose={() =>
                        this.setState(
                          produce((draft) => {
                            draft.archiveDeleteResponseAffNetwork = null;
                          })
                        )
                      }
                    >
                      <span>{this.state.archiveDeleteResponseAffNetwork}</span>
                    </Notification>
                  )}
                </Fade>
              </NotificationGroup>
            )}
          </div>
        </Layout>
      </Fragment>
    );
  }
}

export const mapStateToProps = createStructuredSelector({
  domainsDataReceived: makeSelectDomainsDataReceived(),
  loadAffiliateNetworkData: makeSelectAffiliatedNetworkDataLoaded(),
  isAffiliateNetworkDeleted: makeSelectIsDeleteAffiliateNetworkDataSent(),
  isAllAffiliateNetworksDataLoaded:
    makeSelectIsAllAffiliateNetworksDataLoaded(),
  isNewAffiliateNetworkDataSent: makeSelectIsNewAffiliateNetworkDataSent(),
  isEditAffiliateNetworkDataReceived:
    makeSelectIsEditAffiliateNetworkDataReceived(),
  isPatchedAffiliateNetworkDataSent:
    makeSelectIsPatchedAffiliateNetworkDataSent(),
  loadCustomAffiliateNetworkDataReceived:
    makeSelectCustomAffiliateNetworkData(),
  loadCustomAffiliateNetworkDataReceivedById:
    makeSelectCustomAffiliateNetworkDataById(),
  isAffNetworkArchived: makeSelectIsAffNetworkArchived(),
  isChartsDataLoaded: makeSelectIsChartsDataLoaded(),
  chartsAllDataLoaded: makeSelectAllChartsDataLoaded(),
  isMovedToWorkspace: makeSelectMoveToWorkspace(),
  accessToken: makeSelectToken(),
  Error: makeSelectError(),
  archiveDeleteResponseAffNetwork: makeSelectArchiveDeleteResponseAffNetwork(),
});
export function mapDispatchToProps(dispatch) {
  return {
    dispatchLoadAffiliateNetwork: (...payload) =>
      dispatch(affiliatedNetworksActions.loadAffiliateNetwork(...payload)),
    dispatchLoadDomains: (...payload) =>
      dispatch(loadCustomDomains(...payload)),
    dispatchDeleteAffiliateNetwork: (...payload) =>
      dispatch(deleteAffiliateNetwork(...payload)),
    dispatchCloseEditDialogue: () =>
      dispatch(closeEditAffiliateNetworkDialogue()),
    dispatchLoadAllCustomAffiliateNetworks: (...payload) =>
      dispatch(
        affiliatedNetworksActions.loadCustomAffiliateNetwork(...payload)
      ),
    dispatchLoadCustomAffiliateNetworkById: (...payload) =>
      dispatch(
        affiliatedNetworksActions.loadCustomAffiliateNetworkById(...payload)
      ),
    dispatchArchiveAffiliateNetwork: (...payload) =>
      dispatch(affiliatedNetworksActions.archiveAffiliateNetwork(...payload)),
    dispatchLoadChartsData: (...payload) =>
      dispatch(affiliatedNetworksActions.loadAffNetworkChartsData(...payload)),
    dispatchMoveToWorkspace: (...payload) =>
      dispatch(moveToWorkspace(...payload)),
    resetEditAffNetworkData: () =>
      dispatch(affiliatedNetworksActions.resetCustomDataById()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateNetworks);

function ResponsiveMenuCharts(props) {
  const [dimensions, setDimensions] = React.useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })
  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    
}

    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)
    
}
  })
  return <>{//<div>{window.innerWidth}</div>
  }
  <MenuCharts data={props.data} dates={props.dates}/>
  </>

}